import {useQuery} from "@tanstack/react-query";
import {useSelector} from "react-redux";
import {getData} from "../../../app/getters/getData.js";

export const useHistoriaPlanHarm = (planHarmId, enabled = true) => {

    const role = useSelector(state => state.user.role) // to string
    const roleParam = role === 'oper' ? 'oper/' : '/'
    const endpoint = `${roleParam}plan-harm/historia/${planHarmId}`;

    return useQuery({
        queryKey: [`historia_plan_harm`, planHarmId],
        queryFn: () => getData(endpoint),
        enabled: enabled,
        refetchOnMount: true,
    })
}